import React from "react";
import PropTypes from "prop-types";
import { InputGroup, InputGroupAddon, Input } from "reactstrap";
import SearchImage from "images/search_icon.svg";
import "./index.css";

const TableSearchInput = ({ name, value, placeholder, onChange, children }) => {
  return (
    <InputGroup>
      <InputGroupAddon addonType="prepend">
        <img
          src={SearchImage}
          alt="SearchImage here"
          className="search-icon-input"
        />
      </InputGroupAddon>
      <Input
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
      {children}
    </InputGroup>
  );
};

TableSearchInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.any
};

export default TableSearchInput;
